import { render, staticRenderFns } from "./IconStepperActive.vue?vue&type=template&id=937f1d9e"
import script from "./IconStepperActive.vue?vue&type=script&lang=js"
export * from "./IconStepperActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports